module.exports = __webpack_public_path__ + "static/media/LK_upload.06fb6b9b.svg";